import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import LeavePlan from "..";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import { CommonReducerAction, setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import { ReducersTypes } from "../../../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isprorate: true,
  proratetypeid: 1,
  creditmodetypeid: 1,
  midjoinstartday: 0,
  isextentionprobation: null,
  isprobationaccurallimit: false,
};
class ProRate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
    this.getEmploymentType();
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        proratetypeid: props.InitLeavesPolicy.policy[ParentIndex].proratetypeid,
        creditmodetypeid:
          props.InitLeavesPolicy.policy[ParentIndex].creditmodetypeid,
        midjoinstartday:
          props.InitLeavesPolicy.policy[ParentIndex].midjoinstartday,
        isextentionprobation:
          props.InitLeavesPolicy.policy[ParentIndex].isextentionprobation,
        isprobationaccurallimit:
          props.InitLeavesPolicy.policy[ParentIndex].isprobationaccurallimit,
      }, () => {
        this.getEmploymentType();
      });
    } else {
      this.setState({ ...ParentState }, () => this.getEmploymentType());
    }
  }

  getEmploymentType() {
    instance.get(`/superuser/getmastercode/EmploymentType`).then(
      (result) => {
        const policyDet = this.props.InitLeavesPolicy.policy[
          this.state.ParentIndex
        ];
        const EmploymentTypeList = result.data.result;
        if (EmploymentTypeList.length > 0) {
          EmploymentTypeList.unshift({ displayname: "All", displayvalue: 0 });
        }
        let ids = null;
        if (policyDet) {
          ids = policyDet.employeetypeids;
          ids = ids && ids.split(",");
        }
        this.setState(
          {
            EmploymentTypeList,
            // employeetypeids: policyDet ? typeof policyDet.employeetypeids === 'string' ? JSON.parse(policyDet.employeetypeids) : policyDet.employeetypeids : null
            employeetypeids: ids,
          },
          () => {
            const { employeetypeids } = this.state;
            const employeetype = [];
            if (employeetypeids) {
              for (const id of employeetypeids) {
                const filterObj = this.state.EmploymentTypeList.find(
                  (x) => x.displayvalue == id,
                );
                employeetype.push(filterObj);
              }
            }
            this.setState({ employeetype });
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "isprorate":
        this.setState({ [name]: arg[0] });
        break;
      case "proratetypeid":
        this.setState(
          {
            [name]: arg[0],
            creditmodetypeid: 0,
            isextentionprobation: false,
            midjoinstartday: 0,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "creditmodetypeid":
        this.setState({ [name]: arg[0], midjoinstartday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      case "isprobationaccurallimit":
      case "isextentionprobation":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "employeetype":
        {
          let filterObj = arg[0] && arg[0].findIndex((x) => x.displayvalue == 0);
          if (filterObj != null && filterObj >= 0) {
            filterObj = this.state.EmploymentTypeList.filter(
              (x) => x.displayvalue != 0,
            );
            this.setState({ [name]: filterObj }, () => {
              this.multiOptions(name, filterObj);
            });
          } else {
            this.setState({ [name]: arg[0] && arg.length > 0 ? arg[0] : [] }, () => {
              this.multiOptions(name, arg[0] && arg.length > 0 ? arg[0] : []);
            });
          }
        }
        break;
      default:
        break;
    }
  }

  multiOptions(name, arg) {
    let obj = [];
    for (const val of arg) {
      obj.push(val.displayvalue);
    }
    obj = obj.length > 0 ? obj : (obj = null);
    switch (name) {
      case "employeetype":
        this.setState({ employeetypeids: obj }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      proratetypeid: this.state.proratetypeid,
      creditmodetypeid: this.state.creditmodetypeid,
      midjoinstartday: this.state.midjoinstartday,
      isextentionprobation: this.state.isextentionprobation,
      isprobationaccurallimit: this.state.isprobationaccurallimit,
      employeetypeids: this.state.employeetypeids
        ? this.state.employeetypeids.join()
        : this.state.employeetypeids,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max)
        || Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = event.target.value;
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  render() {
    const language = this.props.Language.leavepolicycommon;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="margin-top-20">
          <p className="form-main-header">
            <FormattedMessage
              id="LbCalculationsDisbursal"
              defaultMessage="Calculations & Disbursal"
            />
          </p>
          {/* <FormattedMessage id="LbHowToEarnLeaveBal" defaultMessage="How can employees earn their leave balance?" /> */}
          <div className="inner-wrapper opaque">
            <div className="">
              <p className="form-sub-header">
                <FormattedMessage
                  id="LbAvailBalance"
                  defaultMessage="Who can avail this leave balance?"
                />
              </p>
              <div className="margin-bottom-20">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbEmploymentType"
                    defaultMessage="Employment Type"
                  />
                </p>
                <Select
                  className="form-control width58"
                  autofocus
                  placeholder="Select Employment Type"
                  isMulti
                  options={this.state.EmploymentTypeList}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  onChange={this.handleChange.bind(this, "employeetype")}
                  value={this.state.employeetype}
                />
              </div>
              <p className="form-sub-header">
                <FormattedMessage
                  id="LbCalculateLeaveBalance"
                  defaultMessage="How will the leave balance be calculated?"
                />
              </p>
              {/* <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isprorate", true)}
                aria-expanded={this.state.isprorate}
              >
                <span>
                  <FormattedMessage id="LbProRate" defaultMessage="Pro-Rate" />
                </span>
                {this.state.isprorate == true ? (
                  <span className="floatright">
                    {" "}
                    <img src={CheckImg} height="20" />{" "}
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isprorate}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("proratetypeid", 1)}
                    aria-expanded={this.state.proratetypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="LbFromJoining"
                        defaultMessage=" Pro-rate from joining date"
                      />
                    </span>
                    {this.state.proratetypeid == 1 ? (
                      <span className="floatright">
                        {" "}
                        <img src={CheckImg} height="20" />{" "}
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.proratetypeid == 1}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 1)}
                        aria-expanded={this.state.creditmodetypeid == 1}
                      >
                        <span>
                          <FormattedMessage
                            id="LbIrrespectiveOfJoining"
                            defaultMessage="Calculate leaves for the joining month, irrespective of joining date"
                          />
                        </span>
                        {this.state.creditmodetypeid == 1 ? (
                          <span className="floatright">
                            {" "}
                            <img src={CheckImg} height="20" />{" "}
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 2)}
                        aria-expanded={this.state.creditmodetypeid == 2}
                      >
                        <span>
                          <FormattedMessage
                            id="LbEmployeesJoinAfter"
                            defaultMessage="Calculate half month’s leave for joining month, if employee joins after "
                          />
                        </span>
                        {this.state.creditmodetypeid == 2 ? (
                          <span className="floatright">
                            {" "}
                            <img src={CheckImg} height="20" />{" "}
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div className="et-level4">
                        <Collapse
                          in={this.state.creditmodetypeid == 2}
                          timeout={2}
                          unmountOnExit
                          className="padding30 overflow-initial"
                        >

                          <InputValues
                            min="1"
                            max="29"
                            field="midjoinstartday"
                            onChange={this.CommonNumberChange.bind(this, "midjoinstartday", 29)}
                            value={this.state.midjoinstartday}
                            defaultvalue={this.state.midjoinstartday}
                          />
                        </Collapse>
                      </div>
                    </Collapse>
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("proratetypeid", 2)}
                    aria-expanded={this.state.proratetypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbFromProbation"
                        defaultMessage="Pro-rate from probation end date"
                      />
                    </span>
                    {this.state.proratetypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.proratetypeid == 2}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange(
                            "isextentionprobation",
                            !this.state.isextentionprobation,
                          )
                        }
                        aria-expanded={this.state.isextentionprobation}
                      >
                        <span>
                          <FormattedMessage
                            id="LbIncludeExtrendedProbation"
                            defaultMessage="Include extended probation, if any"
                          />
                        </span>
                        {this.state.isextentionprobation ? (
                          <span className="floatright selected-box">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <path d="M0 0h24v24H0z" fill="none" />
                              <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                            </svg>
                          </span>
                        ) : (
                          <span className="not-selected-box" />
                        )}
                      </div>
                      <p className="depedent-select-list-head padding15">
                        <FormattedMessage
                          id="LbCalculateForProbation"
                          defaultMessage="How do we calculate leave for probation (or extended probation) that ends inthe middle of a month?"
                        />
                      </p>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 1)}
                        aria-expanded={this.state.creditmodetypeid == 1}
                      >
                        <span>
                          <FormattedMessage
                            id="LbCalProbationEndMonth"
                            defaultMessage="Calculate leaves for the probation end month "
                          />
                        </span>
                        {this.state.creditmodetypeid == 1 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 2)}
                        aria-expanded={this.state.creditmodetypeid == 2}
                      >
                        <span>
                          <FormattedMessage
                            id="LbEmployeesJoinAfterDateProbation"
                            defaultMessage="Calculate half month’s leave for probation end month, if probation end date is after"
                          />
                        </span>
                        {this.state.creditmodetypeid == 2 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div className="et-level4">
                        <Collapse
                          in={this.state.creditmodetypeid == 2}
                          timeout={2}
                          unmountOnExit
                          className="padding30 overflow-initial"
                        >

                          <InputValues
                            min="1"
                            max="29"
                            field="midjoinstartday"
                            onChange={this.CommonNumberChange.bind(this, "midjoinstartday", 29)}
                            value={this.state.midjoinstartday}
                            defaultvalue={this.state.midjoinstartday}
                          />
                          <span> days</span>
                        </Collapse>
                      </div>
                    </Collapse>
                  </div>
                </Collapse>
              </div> */}

              <p className="form-sub-header margin-top-20">
                <FormattedMessage
                  id="LbCalculateLeaveBalance"
                  defaultMessage="When will the leave balance be available for employees to use?"
                />
              </p>
              <p className="form-input-label">
                <p className="form-input-label">
                  <FormattedMessage
                    id="LbAllowLeaveAccural"
                    defaultMessage="Do you want to allow leave accrual during Probation?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() =>
                    this.handleChange("isprobationaccurallimit", true)
                  }
                  aria-expanded={this.state.isprobationaccurallimit}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isprobationaccurallimit == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                      <span className="not-selected" />
                    )}
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() =>
                    this.handleChange("isprobationaccurallimit", false)
                  }
                  aria-expanded={this.state.isprobationaccurallimit == false}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.isprobationaccurallimit == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                      <span className="not-selected " />
                    )}
                </div>
              </p>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
ProRate.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ProRate)));
